/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

export const defaultBrand = {
  botType: '',
  fontColor: '#FFFFFF',
  messagingEndpoint: '',
  primaryColor: '#124459',
  title: 'Bot not found'
};
